import { all, call, put, takeLatest, select } from "redux-saga/effects";
import { http } from "../../common/lib";
import config from "../../config";
import { actionCreators, actionTypes } from "./actions";
import { logToSentry } from "../../config/Sentry";

function* getRequest() {
    const { auth } = yield select((state) => state);
    const { identityId } = auth;
    let orgUrl;
    try {
        orgUrl = `${config.api.paths.organisations}?identity_id=${identityId}`;
        const res = yield call(http.authorized.get, orgUrl);
        yield put(actionCreators.getSuccess(res.data));
    } catch (error) {
        const errStr = error.toString();
        logToSentry("organisation get", {
            error,
            errStr,
            orgUrl,
        });
        yield put(actionCreators.getFailure(errStr));
    }
}

export { getRequest };

export default (function* () {
    yield all([takeLatest(actionTypes.ORGANISATIONS_GET_REQUEST, getRequest)]);
})();
